// Spanish strings. Mirrors the keys in en.js. Any key missing here falls back
// to the English value automatically, so this file can grow incrementally.

const es = {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    search: 'Buscar…',
    viewAll: 'Ver todo',
    loading: 'Cargando…',
    newTour: 'Nuevo Tour',
    all: 'Todos',
    delete: 'Eliminar',
    view: 'Ver →',
    generating: 'Generando…',
  },
  dashboard: {
    greetingMorning: 'Buenos días',
    greetingAfternoon: 'Buenas tardes',
    greetingEvening: 'Buenas noches',
    headerSub: 'Esto es lo que requiere tu atención hoy.',
    actionRequired: 'Acción requerida',
    reviewTours: 'Revisar tours →',
    chaseInvoices: 'Reclamar facturas →',
    viewAll: 'Ver todo',
    // KPI cards
    awaitingReview: 'Pendientes de revisión',
    awaitingReviewSub: 'nuevas solicitudes',
    departures30d: 'Salidas · 30d',
    departures30dSub: 'próximos 30 días',
    activeTours: 'Tours activos',
    activeToursSub: 'en operaciones',
    completedTours: 'Tours completados',
    completedToursSub: 'checklist post-tour completado',
    outstanding: 'Pendiente de cobro',
    // Card titles
    revenue: 'Ingresos',
    tourPipeline: 'Flujo de tours',
    pipelineSub: 'Tours en curso por etapa',
    toursInProgress: 'Tours en curso',
    needsAttention: 'Requiere atención',
    invoicesDue: 'Facturas por cobrar',
    outstandingSuffix: 'pendiente',
    nextDepartures: 'Próximas salidas',
    nextDeparturesSub: 'Cuenta atrás para la salida',
    noOutstanding: 'No hay facturas pendientes.',
    operationsWorkload: 'Carga de operaciones',
    totalLivePipeline: 'Pipeline activo total',
    periodToday: 'Hoy', periodWeek: 'Semana', periodMonth: 'Mes',
    periodYear: 'Año', periodQuarter: 'Trimestre',
  },
  category: {
    all: 'Todos',
    sales_admin: 'Ventas y administración',
    tour_preparation: 'Preparación del tour (operaciones)',
    leader_handover: 'Traspaso al jefe de grupo',
    leader_signoff: 'Aprobación del jefe de grupo',
    post_tour: 'Post-tour',
    cancelled: 'Cancelado',
    archived: 'Archivados',
  },
  tours: {
    title: 'Tours',
    countSuffix: 'en el sistema',
    inOperations: 'en operaciones',
    filterAll: 'Todos',
    filterCancelled: 'Cancelados',
    noneTitle: 'No hay tours en esta categoría',
    noneDesc: 'Los tours aparecerán aquí una vez creados.',
    noMatchTitle: 'Ningún tour coincide con "{term}"',
    noMatchDesc: 'Prueba con otro término de búsqueda o quita el filtro.',
    loadMore: 'Cargar más tours',
    searchPlaceholder: 'Buscar tours…',
  },
  invoices: {
    title: 'Facturas',
    subtitle: 'Todas las facturas y plazos de cada reserva',
    viewByRequest: 'Por reserva', viewAllInvoices: 'Todas las facturas',
    filterAll: 'Todas', filterUnpaid: 'Pendientes', filterPaid: 'Pagadas',
    outstanding: 'Pendiente de cobro', received: 'Cobrado', totalInvoices: 'Total de facturas',
    paidLower: 'pagadas', outstandingLower: 'pendientes',
    collectionRate: 'Tasa de cobro', ofTotalCollected: 'del valor total facturado cobrado',
    noneFound: 'No se encontraron facturas.', allPaid: 'Todo pagado', nUnpaid: '{n} pendientes',
    receivedTotal: 'Cobrado / Total',
    colInvoice: 'Factura', colRequest: 'Reserva', colInstalment: 'Plazo',
    colAmount: 'Importe', colDue: 'Vencimiento', colStatus: 'Estado',
    markPaid: 'Marcar pagada', markUnpaid: 'Marcar pendiente',
    chipPaid: 'Pagada', chipUnpaid: 'Pendiente',
    agingOverdue: 'Vencida {n}d', agingDueIn: 'Vence en {n}d', agingDue: 'Vence {date}',
  },
  calendar: {
    title: 'Calendario de tours',
    subtitle: 'Vista en directo de tours provisionales y confirmados.',
    statusProvisional: 'Provisional', statusConfirmed: 'Confirmado', statusCompleted: 'Completado',
    addEvent: 'Añadir evento', addTeamEvent: 'Añadir evento del equipo', teamEvent: 'Evento del equipo',
    addedBy: 'Añadido por {name}',
  },
  newTour: {
    title: 'Nueva solicitud de tour',
    subtitle: 'Crea una solicitud en nombre de un cliente.',
    backToRequests: '← Volver a tours',
    stepCustomer: 'Cliente', stepTourDetails: 'Detalles del tour', stepGroupInfo: 'Información del grupo', stepReview: 'Revisión',
    brand: 'Marca', customer: 'Cliente', tourDetails: 'Detalles del tour',
    whatsIncluded: 'Qué incluye', groupInfo: 'Información del grupo',
    contactName: 'Nombre de contacto', departureDate: 'Fecha de salida', returnDate: 'Fecha de regreso',
    phone: 'Teléfono', createSelectCustomer: 'Crear y seleccionar cliente', creatingCustomer: 'Creando…',
    back: '← Atrás', continue: 'Continuar →', stepOf: 'Paso {n} de 4',
    creating: 'Creando…', createRequest: 'Crear solicitud',
  },
  tour: {
    tabOverview: 'Resumen',
    tabQuote: 'Presupuesto',
    tabOps: 'Operaciones',
    tabItinerary: 'Itinerario',
    tabRooming: 'Habitaciones',
    tabFlights: 'Vuelos de grupo',
    tabTeams: 'Equipos',
    tabRegisters: 'Registros',
    tabExpenses: 'Gastos',
    tabTeamInfo: 'Datos del equipo',
    tabSocial: 'Redes sociales',
    tabLetters: 'Cartas',
    tabResources: 'Documentación',
    tabMessages: 'Mensajes',
    tabPreviews: 'Vistas previas',
    breadcrumbDashboard: 'Panel',
    breadcrumbTours: 'Tours',
    secTourDetails: 'Detalles del tour', secGroupInfo: 'Información del grupo', secGroupType: 'Tipo de grupo',
    secContact: 'Contacto', secItinerary: 'Itinerario',
  },
  // ── Portal de Operaciones de Fútbol (+ las vistas de solo lectura que comparte) ──
  footballOps: {
    portalName: 'Operaciones de Fútbol', badge: 'Op. Fútbol', opsView: 'Vista de operaciones', signOut: 'Cerrar sesión',
    toursTitle: 'Tours', toursSub: 'Datos de los equipos, partidos, equipos e itinerarios de cada tour reservado.',
    upcoming: 'Próximos y en curso', past: 'Pasados', allSports: 'Todos los deportes', searchTours: 'Buscar tours…',
    noToursTitle: 'Todavía no hay tours', noToursDesc: 'Los tours reservados aparecerán aquí. Contacta con MST si crees que deberías ver alguno.',
    noMatchTitle: 'Ningún tour coincide', noMatchDesc: 'Prueba con otro filtro o búsqueda.',
    travellers: '{n} viajeros', squadOne: '1 plantilla', squadMany: '{n} plantillas', pax: '{n} pax',
    allTours: 'Todos los tours', tourNotFound: 'Tour no encontrado.', loading: 'Cargando…',
    tabOverview: 'Resumen', tabFixtures: 'Partidos', tabTeamInfo: 'Datos del equipo', tabTeams: 'Equipos',
    tabItinerary: 'Itinerario', tabSkeleton: 'Esquema', tabNotes: 'Notas',
    secTourDetails: 'Detalles del tour', secFlights: 'Vuelos', secPeople: 'Personas', secGroupNotes: 'Notas del grupo',
    fSport: 'Deporte', fDestination: 'Destino', fHotel: 'Hotel', fDeparture: 'Salida', fReturn: 'Regreso',
    fGroupType: 'Tipo de grupo', fTotalTravellers: 'Total de viajeros', fPlayers: 'Jugadores', fSquads: 'Equipos / plantillas',
    fAirline: 'Aerolínea', fOutboundFlight: 'Vuelo de ida', fOutboundDeparture: 'Salida (ida)',
    fArrivalTime: 'Hora de llegada', fReturnFlight: 'Vuelo de vuelta', fReturnDeparture: 'Salida (vuelta)',
    fReturnArrival: 'Llegada (vuelta)', fGroupContact: 'Contacto del grupo', fPhone: 'Teléfono', fEmail: 'Email',
    fTourLeader: 'Jefe de grupo', fTourLeaders: 'Jefes de grupo', fTotalGoalkeepers: 'Total de porteros',
    noTeamInfoTitle: 'Todavía no se han enviado los datos del equipo', noTeamInfoDesc: 'Aparecerán aquí cuando el entrenador rellene el formulario.',
    coachTeamInfo: 'Datos del entrenador y del equipo',
    teamsNotSetTitle: 'Los equipos aún no están creados', teamsNotSetDesc: 'Los equipos aparecen cuando se rellena el formulario de datos del equipo o cuando MST los crea.',
    unplacedOne: '1 jugador inscrito aún no está en ningún equipo.', unplacedMany: '{n} jugadores inscritos aún no están en ningún equipo.',
    playerOne: '1 jugador', playerMany: '{n} jugadores', noPlayersPlaced: 'Todavía no hay jugadores asignados.',
    noAccess: 'No tienes acceso a ninguna parte de este tour. Contacta con MST si lo necesitas.',
  },
  portals: { uk_to_spain: 'Reino Unido a España', spain_to_uk: 'España a Reino Unido', padelante: 'Padelante' },
  squad: {
    squadN: 'Plantilla {n}', gender: 'Sexo', yearsOfBirth: 'Año(s) de nacimiento', playersPerMatch: 'Jugadores / partido',
    ability: 'Nivel', homeKit: 'Equipación local', awayKit: 'Equipación visitante', jersey: 'Camiseta', jersey2: 'Camiseta 2',
    shorts: 'Pantalón', socks: 'Medias', pattern: 'Diseño:', oneKitOnly: 'Solo una equipación',
    preferredFixture: 'Partido preferido (buscador de partidos)', date: 'Fecha', time: 'Hora', location: 'Lugar', ko: 'Inicio {time}',
    copyFinder: 'Copiar texto del buscador', copied: '¡Texto del buscador de partidos copiado!', born: 'nacidos en {years}',
  },
  skeleton: {
    none: 'Todavía no hay itinerario esquemático: el personal de MST aún no lo ha preparado para este tour.',
    draft: 'Borrador', pending_admin: 'Pendiente de aprobación interna', pending_group: 'Pendiente de aprobación del grupo', approved: 'Aprobado',
    slots: {
      arrival: 'Llegada', breakfast: 'Desayuno', morning1: 'Mañana', morning2: 'Mañana', lunch: 'Comida',
      afternoon1: 'Tarde', afternoon2: 'Tarde', evening1: 'Noche', evening2: 'Noche',
      evmeal: 'Cena', departure: 'Salida', activity: 'Actividad',
    },
  },
  notes: {
    title: 'Notas', none: 'Todavía no hay notas.', tour: 'Tour', fromTour: 'De {label}', anotherTour: 'otro tour',
    unknown: 'Desconocido', justNow: 'Ahora mismo', earlier: 'Notas anteriores', legacyHint: 'Del antiguo cuadro de notas, antes de que las notas llevaran fecha',
  },
  fixtures: {
    title: 'Partidos', countOne: '1 partido · los equipos vienen de la pestaña Equipos', countMany: '{n} partidos · los equipos vienen de la pestaña Equipos',
    noTeams: 'Todavía no hay equipos. Se crean a partir de las plantillas cuando se rellena el formulario de datos del equipo, o se pueden añadir en la pestaña Equipos.',
    noFixtures: 'Todavía no hay partidos.', yourTeam: 'Tu equipo', tourLeader: '· Jefe de grupo: {name}',
    onItinerary: 'En el itinerario: {days}', dayN: 'Día {n}',
    notOnItinerary: 'Aún no está en el itinerario. Añádelo desde una actividad de partidos.',
    teamRemoved: 'Equipo eliminado', vs: ' vs ', oppTbc: 'Rival por confirmar', oppCoach: 'Entrenador rival', referee: 'Árbitro',
    home: 'Local', away: 'Visitante', oneKitOnly: '(solo una equipación)', matchOne: '1 partido', matchMany: '{n} partidos',
    shirt: 'camiseta {c}', shorts: 'pantalón {c}', socks: 'medias {c}',
    clashAway: 'El rival viste de {c}, como nuestra camiseta local. Usad la equipación visitante.',
    clashBoth: 'El rival viste de {c}, como nuestras dos equipaciones. Llevad petos.',
    clashNoAway: 'El rival viste de {c}, como nuestra camiseta, y no hay equipación visitante. Llevad petos.',
  },
  itinerary: {
    needsDetails: 'Faltan detalles',
    dayN: 'Día {n}', noActivities: 'No hay actividades este día.',
    noDates: 'No hay fechas del tour: añade primero las fechas de salida y regreso.',
    exportGroup: 'Exportar para el grupo', generating: 'Generando…',
    exportAll: 'Exportar itinerario completo', exportFiltered: 'Exportar solo {name}',
    filterSupplier: 'Proveedor', allSuppliers: 'Todos los proveedores', noSupplier: 'Sin proveedor',
    showingN: 'Mostrando {n} de {total} actividades', clearFilter: 'Quitar',
    colTime: 'Hora', colActivity: 'Actividad', colLeaderNotes: 'Notas para jefes de grupo', colLocation: 'Lugar', colSupplier: 'Proveedor', colStatus: 'Estado', colTicket: 'Entrada',
    ticket: 'Entrada', question: '💬 Pregunta', activity: 'Actividad',
    status: {
      not_required: 'Aprobado automáticamente', pending: 'Pendiente', approved: 'Aprobado', overridden: 'Aprobado automáticamente',
      declined: 'Rechazado', question: 'Tiene una pregunta',
    },
    booking: { confirmed: 'Disponibilidad confirmada', declined: 'Disponibilidad rechazada', pending: 'Pendiente de confirmación' },
    transfer: { bus: '🚌 Autobús', tram: '🚊 Tranvía', walk: '🚶 A pie' },
    pickup: 'Recogida', dropoff: 'Destino', supplierContact: 'Contacto del proveedor', openMaps: 'Abrir en Google Maps',
    noDetails: 'No hay más detalles.', close: 'Cerrar',
  },
  // Known data values, keyed by lower-cased English text (see t.value).
  supplier: {
    portal: 'Portal de proveedores', role: 'Proveedor', pendingN: '{n} pendientes', signOut: 'Cerrar sesión', loading: 'Cargando…',
    yourTours: 'Tus tours', noCurrent: 'No hay tours en curso ni próximos.',
    noTours: 'Todavía no tienes tours asignados. MST te avisará cuando algo requiera tu atención.', noToursShort: 'Todavía no tienes tours asignados.',
    nothingComing: 'No hay nada próximo. Marca «Mostrar tours pasados» para ver los anteriores.',
    countUpcomingOne: '1 tour en curso o próximo · pulsa un tour para ver los detalles y responder',
    countUpcomingMany: '{n} tours en curso o próximos · pulsa un tour para ver los detalles y responder',
    countAllOne: '1 tour · pulsa un tour para ver los detalles y responder', countAllMany: '{n} tours · pulsa un tour para ver los detalles y responder',
    showPast: 'Mostrar tours pasados ({n})', activityOne: '1 actividad', activityMany: '{n} actividades',
    calendar: {
      listView: 'Lista', calendarView: 'Calendario', today: 'Hoy', prev: 'Mes anterior', next: 'Mes siguiente',
      more: '+{n} más', activityDay: 'Tu actividad', thisMonth: 'Tours de este mes', none: 'No hay tours este mes.',
      legendUpcoming: 'Reservado', legendAction: 'Requiere tu respuesta', legendPast: 'Finalizado',
    },
    badge: { itinerary: 'Itinerario pendiente de aprobación', pending: 'Pendiente de confirmación', confirmed: 'Confirmado', declined: 'Rechazado' },
    docs: {
      title: 'Documentos de cumplimiento', desc: 'Seguros, certificados de seguridad e higiene y demás documentación obligatoria.',
      upload: 'Subir', name: 'Nombre del documento', namePh: 'p. ej. Seguro de responsabilidad civil 2025', type: 'Tipo de documento', file: 'Archivo',
      uploading: 'Subiendo {n}%…', uploadBtn: 'Subir documento', none: 'Todavía no has subido documentos.', view: 'Ver ↗',
      failed: 'No se pudo subir. Inténtalo de nuevo.',
      types: { insurance: 'Seguro', health_safety: 'Seguridad y salud', hygiene_cert: 'Certificado de higiene', pool_maintenance: 'Mantenimiento de piscina', fire_escape: 'Plan de evacuación', other: 'Otros' },
    },
    tabs: { booking: 'Reserva', tour: 'Info del tour', participants: 'Participantes', itinerary: 'Itinerario', rooming: 'Habitaciones', food: 'Comida', contractor: 'Colaborador' },
    myTours: 'Mis tours', unavailableTitle: 'Este tour no está disponible',
    unavailableBody: 'No tienes ninguna reserva ni actividad asignada en él. Si crees que es un error, contacta con MST.',
    pax: '{n} pax', approvalRequired: 'Aprobación del itinerario pendiente', bookingRequired: 'Confirmación de reserva pendiente',
    bookingTitle: 'Confirmación de reserva', yourActivities: 'Tus actividades', noActivities: 'Todavía no tienes actividades asignadas en este tour.',
    fullDetails: 'Todos los detalles en Itinerario →', day: 'Día {n}', dayTbc: 'Día por confirmar', until: 'Hasta las {time}',
    status: {
      pending: 'Pendiente de tu aprobación', not_sent: 'Aún no enviado para aprobación', approved: 'Aprobado', overridden: 'Confirmado',
      not_required: 'Confirmado', declined: 'Rechazado', question: 'Pregunta enviada',
    },
    booking: {
      service: 'Servicio', confirmBooking: 'Confirmar reserva', decline: 'Rechazar', confirm: 'Confirmar', cancel: 'Cancelar', saving: 'Guardando…',
      noteConfirm: 'Nota de confirmación (opcional)', noteDecline: 'Motivo del rechazo (opcional)',
      phConfirm: 'p. ej. Confirmado — ref.: 12345', phDecline: 'p. ej. No hay disponibilidad esas fechas', yourNote: 'Tu nota: «{note}»',
      invoice: 'Factura', viewInvoice: 'Ver factura', replace: 'Sustituir', uploading: 'Subiendo {n}%…', uploadInvoice: 'Subir factura',
      invoiceFailed: 'No se pudo subir la factura. Inténtalo de nuevo.',
      statuses: { pending: 'Pendiente de confirmación', confirmed: 'Confirmado', declined: 'Rechazado' },
    },
    approve: {
      items: 'Actividades pendientes de tu aprobación', approveAll: '✓ Aprobar todo', decline: '✕ Rechazar', question: '? Tengo una pregunta',
      whatQuestion: '¿Cuál es tu pregunta?', questionPh: 'Escribe tu pregunta aquí…', saving: 'Guardando…', sending: 'Enviando…',
      send: 'Enviar pregunta', back: 'Volver', failed: 'No se pudo enviar. Inténtalo de nuevo.',
    },
    overview: {
      title: 'Resumen del tour', sport: 'Deporte', destination: 'Destino', departure: 'Salida', return: 'Regreso',
      groupType: 'Tipo de grupo', totalTravellers: 'Total de viajeros', players: 'Jugadores', male: 'Chicos', female: 'Chicas',
    },
    leaders: { one: 'Jefe de grupo', many: 'Jefes de grupo', none: 'Todavía no hay jefe de grupo asignado.', name: 'Nombre', email: 'Email', phone: 'Teléfono', leads: 'Responsable de' },
    teams: {
      info: 'Datos del equipo', squads: 'Plantillas', goalkeepers: 'Porteros', teams: 'Equipos',
      noLinked: 'Todavía no hay equipos asignados a tus partidos.', notSubmitted: 'Todavía no se han enviado los datos del equipo.',
      playersN: 'Jugadores de {team} · {n}', noPlayers: 'Todavía no hay jugadores en este equipo.',
    },
    participants: {
      title: 'Datos de los participantes', none: 'Todavía no se han enviado datos de participantes.',
      countOne: '1 participante', countMany: '{n} participantes', export: 'Exportar CSV',
      reqTitle: 'Necesidades alimentarias / médicas / de seguridad', reqCountOne: '1 participante con necesidades', reqCountMany: '{n} participantes con necesidades',
      allergies: 'Alergias:', dietary: 'Alimentación:', medical: 'Médico:', safety: 'Seguridad:', requirements: 'Necesidades',
      personal: 'Datos personales', fullName: 'Nombre completo', dob: 'Fecha de nacimiento', dobShort: 'Nac.: {d}', gender: 'Sexo', nationality: 'Nacionalidad',
      passport: 'Pasaporte / viaje', passportNo: 'N.º de pasaporte', expiry: 'Caducidad', countryOfIssue: 'País de expedición',
      contact: 'Contacto', phone: 'Teléfono', email: 'Email', guardian: 'Padre / madre / tutor', name: 'Nombre', participantN: 'Participante {n}',
      csv: {
        no: 'N.º', fullName: 'Nombre completo', travellerType: 'Tipo de viajero', dob: 'Fecha de nacimiento', gender: 'Sexo', nationality: 'Nacionalidad',
        passportNo: 'N.º de pasaporte', passportExpiry: 'Caducidad del pasaporte', countryOfIssue: 'País de expedición', allergies: 'Alergias',
        dietary: 'Necesidades alimentarias', medical: 'Condiciones médicas', safety: 'Información de seguridad', contactPhone: 'Teléfono de contacto',
        contactEmail: 'Email de contacto', guardianName: 'Nombre del tutor', guardianPhone: 'Teléfono del tutor', guardianEmail: 'Email del tutor',
      },
    },
    itinerary: {
      yourActivitiesHint: 'Las actividades de las que eres proveedor. Puedes subir una entrada en PDF para cada una.', full: 'Itinerario completo',
      none: 'Todavía no hay actividades en el itinerario.', noneToDisplay: 'No hay actividades que mostrar.', ticket: '↓ Entrada', replace: '↑ Sustituir',
      uploadTicket: '↑ Subir entrada', uploadFailed: 'No se pudo subir la entrada. Inténtalo de nuevo.', removeConfirm: '¿Quitar esta entrada?',
      removeFailed: 'No se pudo quitar la entrada. Inténtalo de nuevo.',
    },
    rooming: { title: 'Habitaciones', none: 'Todavía no se han asignado las habitaciones.', staff: 'Personal de MST', beds: '{n} camas', empty: 'Vacía', room: 'Habitación {n}' },
    food: { sandwich: 'Pedidos de bocadillos', tgb: 'Pedidos de TGB', bela: 'Pedidos de Bela Café', none: 'Todavía no hay pedidos.', dateTbc: 'Fecha por confirmar', groupOf: 'Grupo de {n}' },
    confirm: {
      loading: 'Cargando los detalles…', invalidTitle: 'Enlace no válido', invalid: 'Enlace no válido o caducado.',
      notFound: 'No se ha encontrado la actividad del itinerario.', failed: 'Algo ha fallado. Inténtalo de nuevo.',
      contactUs: 'Si crees que es un error, contacta directamente con MST Sports Tours.',
      requestTitle: 'Solicitud de aprobación del itinerario',
      requestIntro: 'MST Sports Tours solicita tu disponibilidad para las siguientes actividades del tour {tour} ({dates}).',
      yourItems: 'Tus actividades', approveAll: '✓ Aprobar todas', declineAll: '✕ Rechazar todas',
      usedTitle: 'Ya has respondido', used: 'Este enlace de aprobación ya se ha utilizado. Contacta con MST Sports Tours si necesitas cambiar tu respuesta.',
      legacyTitle: 'Solicitud de confirmación', legacyIntro: 'MST Sports Tours solicita la confirmación de tu disponibilidad para la siguiente actividad del itinerario.',
      tour: 'Tour', dates: 'Fechas', activity: 'Actividad', day: 'Día', time: 'Hora', notes: 'Notas', confirm: '✓ Confirmar', decline: '✕ Rechazar',
      submitting: 'Enviando tu respuesta…', approved: 'Aprobado', questionSent: 'Pregunta enviada', declined: 'Rechazado',
      approvedBody: 'Gracias, tu disponibilidad ha quedado confirmada. MST Sports Tours se pondrá en contacto contigo con más detalles.',
      questionBody: 'Gracias, tu pregunta se ha enviado al equipo de MST Sports Tours. Se pondrán en contacto contigo en breve.',
      declinedBody: 'Gracias por avisarnos. MST Sports Tours se pondrá en contacto contigo para buscar una alternativa.',
    },
    contractor: {
      updateTitle: 'Actualizar datos de partidos / sesiones', titleField: 'Título / actividad', time: 'Hora', notes: 'Notas (campo, árbitro, rival)',
      save: 'Guardar', cancel: 'Cancelar', edit: 'Editar', saving: 'Guardando…', saveFailed: 'No se pudo guardar.',
      logTitle: 'Registrar gasto', description: 'Descripción', descPh: 'p. ej. Honorarios del árbitro', amount: 'Importe (€)', log: 'Registrar gasto',
      saved: 'Guardado', expenseFailed: 'No se pudo guardar el gasto.',
    },
  },
  values: {
    colour: {
      white: 'blanco', black: 'negro', grey: 'gris', red: 'rojo', blue: 'azul', yellow: 'amarillo', green: 'verde',
      orange: 'naranja', navy: 'azul marino', maroon: 'granate', 'sky blue': 'celeste', purple: 'morado', pink: 'rosa',
    },
    pattern: { plain: 'liso', stripes: 'rayas verticales', hoops: 'rayas horizontales', halves: 'mitades' },
    gender: { male: 'Masculino', female: 'Femenino', mixed: 'Mixto' },
    ability: { low: 'Bajo', medium: 'Medio', high: 'Alto' },
    sport: { football: 'Fútbol', soccer: 'Fútbol', rugby: 'Rugby', netball: 'Netball', hockey: 'Hockey', basketball: 'Baloncesto', padel: 'Pádel', cricket: 'Críquet' },
    activity: {
      hotel: 'Hotel', flights: 'Vuelos', 'airport transfer': 'Traslado aeropuerto', 'coach transfer': 'Traslado en autocar',
      'match arrangement': 'Organización de partido', coaching: 'Entrenamiento', equipment: 'Material', catering: 'Catering',
      other: 'Otros', travel: 'Desplazamiento', fixtures: 'Partidos', fixture: 'Partido', 'meals & catering': 'Comidas',
      training: 'Entrenamiento', excursion: 'Excursión', excursions: 'Excursiones', 'stadium tour': 'Visita al estadio',
      'la liga match': 'Partido de LaLiga', 'free time': 'Tiempo libre',
      lunch: 'Comida', breakfast: 'Desayuno', 'evening meal': 'Cena', 'lunch at hotel': 'Comida en el hotel',
      'arrival at destination': 'Llegada al destino', 'arrival at hotel': 'Llegada al hotel', 'check in hotel': 'Check-in en el hotel',
      'welcome presentation': 'Presentación de bienvenida', 'pool time': 'Piscina', 'beach time': 'Playa', transfers: 'Traslados',
      'extra activities': 'Actividades extra', padel: 'Pádel', yoga: 'Yoga', 'fixture finishes': 'Fin del partido',
      'bus arrive at airport': 'Llegada del autobús al aeropuerto', 'flight land in alicante': 'Aterrizaje en Alicante',
      'watch live game on tv': 'Ver partido en directo por TV', 'sports psychology session': 'Sesión de psicología deportiva',
      'open ceremony': 'Ceremonia de apertura',
    },
    skeleton: {
      'arrival flight': 'Vuelo de llegada', 'departure flight': 'Vuelo de salida', 'training session': 'Sesión de entrenamiento',
      'friendly match': 'Partido amistoso', 'la liga match': 'Partido de LaLiga', 'stadium tour': 'Visita al estadio',
      'coaching session': 'Sesión con entrenador', 'padel session': 'Sesión de pádel', 'free time': 'Tiempo libre',
      'city tour': 'Visita a la ciudad', 'travel day': 'Día de viaje', 'hotel check in': 'Check-in en el hotel',
      'hotel check out': 'Check-out del hotel', 'pool / beach': 'Piscina / playa', 'evening activity': 'Actividad de noche',
      breakfast: 'Desayuno', lunch: 'Comida', 'evening meal': 'Cena',
    },
    title: { breakfast: 'Desayuno', lunch: 'Comida', 'evening meal': 'Cena' },
  },
};

export default es;
